import styled, { css } from 'styled-components';

import { Button } from '../Button/Button';
import { ButtonLink } from '../Button/ButtonLink';

import { media } from '../../../helpers/breakpoints';

const ButtonCSS = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ShowPhoneNumberButton = styled(Button)`
  ${ButtonCSS}
`;

const CallPhoneNumberButtonLink = styled(ButtonLink)`
  ${ButtonCSS}
`;

const ShowPhoneNumberText = styled.span`
  ${media.smallOnly} {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: ${({ theme }) => `0 ${theme.spacing.S12}`};
  }
`;

export {
  ShowPhoneNumberButton,
  CallPhoneNumberButtonLink,
  ShowPhoneNumberText,
};
